import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { RmaRequestType } from "../../../../types/support";
import { createRmaApi } from "../../../../api/support/RMA";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import { useModal } from "../../../../hooks";
import { AxiosError } from 'axios';
/**
 * rma 생성
 * @param props
 * @returns
 */
const useCreateRma = () => {
  const queryClient = useQueryClient();
  const { goToNavigation } = useGoToNavigation();
  const {handleModal} = useModal();

  const { mutate } = useMutation({
    mutationFn: (data: RmaRequestType) => createRmaApi(data),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: ["readRmaList"] });
      queryClient.invalidateQueries({ queryKey: ["readRmaDetail"] });
      goToNavigation(-1, {}, true);
    },
    onError: (error) => {
      let errorMessage = "알 수 없는 오류 발생"; // 기본 메시지

      if (error instanceof AxiosError && error.response?.data?.msg) {
        errorMessage = error.response.data.msg;
      } else if (error instanceof Error) {
        errorMessage = error.message; // 일반 JS 오류 메시지
      }

      handleModal({
        isOpen: true,
        contents: errorMessage,
        type: "alert",
      });
      },
    });
  return { mutate };
};

export default useCreateRma;
